import { render, staticRenderFns } from "./index.vue?vue&type=template&id=17e1a650&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=17e1a650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e1a650",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17e1a650')) {
      api.createRecord('17e1a650', component.options)
    } else {
      api.reload('17e1a650', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=17e1a650&scoped=true&", function () {
      api.rerender('17e1a650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/coach/index.vue"
export default component.exports